export const convertToDoubleStr = (str: string) => (str.length > 1 ? str : '0' + str);
